import { render, staticRenderFns } from "./danh-sach-ung-vien.vue?vue&type=template&id=34c88871&scoped=true"
import script from "./danh-sach-ung-vien.vue?vue&type=script&lang=js"
export * from "./danh-sach-ung-vien.vue?vue&type=script&lang=js"
import style0 from "./danh-sach-ung-vien.vue?vue&type=style&index=0&id=34c88871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c88871",
  null
  
)

export default component.exports